<div class="dashboard">
    <!-- DW-79: Remove banner from the dw-dashboard page -->
    <div class="colum-layout"> 
        <!-- <div class="row-layout">
            <div class="text"> We’ve updated our RewardShip Program 
                <span class="text-link" (click)="openTermsConditions($event)">Terms and Conditions</span>, effective October 23, 2023. Please click 
                <span class="text-link" (click)="openTermsConditions($event)">here</span> to view them.</div>
        </div> -->
        <div class="rectangle"></div>
    </div> 
    <!-- <div class="banner-wrapper">
       
        <div *ngIf="!isUSUser">
            <upsc-image-rotator  [imageItems]="dashboardBannerConfig.images" [speed]="dashboardBannerConfig.speed"
            [isAutoForward]="dashboardBannerConfig.isAutoForward"></upsc-image-rotator>
        </div>

        <div class="banner-Panel" *ngIf="isUSUser">

            <div class="panel">
                <div class="row section">
                    <div class="col-sm-5 image1">
                        <img class="hero-large" src="../../assets/icons/logo-dd-shipping-intelligence.svg" alt="UPS">
                    </div>
                    <div class="col-sm-5 image2">
                        <img class="hero-large" src="../../assets/icons/Content.png" alt="UPS">
                    </div>
                </div>
            </div>
            <img class="hero-small" src="../../assets/icons/ddbannervector.svg" alt="UPS">
        </div>

        <upsc-element-blocker *ngIf="isBannersLoading"></upsc-element-blocker>
    </div> -->


    <upsc-notification-banner *ngIf="customer?.IsPastDue && user?.CountryCode === 'US'" [type]="'error'">
        <div icon>
            <mat-icon>warning</mat-icon>
        </div>
        <div message>
            <span [innerHtml]="'notifications.message' | translate"></span>
            <a routerLink="/billing-history">
                <span [innerHtml]="'notifications.payNow' | translate"></span>
            </a>
        </div>
    </upsc-notification-banner>

    <div class="dashboard-items-wrapper">
        <div class="main-items">
            <ng-container [ngTemplateOutlet]="announcement"></ng-container>
            <div class="dashboard-items">
                <div class="dashboard-item-wrapper" *ngIf="userRoutes?.ShipUPS">
                    <ng-container [ngTemplateOutlet]="shipUps"></ng-container>
                </div>
                <div class="dashboard-item-wrapper" *ngIf="userRoutes?.ShipFedex">
                    <ng-container [ngTemplateOutlet]="shipFedEx"></ng-container>
                </div>
            </div>
            <div class="dashboard-items">
                <div class="dashboard-item-wrapper" *ngIf="!isEUUser">
                    <ng-container [ngTemplateOutlet]="restrictedZip"></ng-container>
                </div>
                <div class="dashboard-item-wrapper">
                    <ng-container [ngTemplateOutlet]="packagingChecklist"></ng-container>
                </div>
            </div>
            <ng-container [ngTemplateOutlet]="quickTrack"></ng-container>
            <ng-container [ngTemplateOutlet]="costEstimator"></ng-container>
        </div>

        <div class="side-items">
            <div class="dashboard-items">
                <div class="dashboard-item-wrapper" *ngIf="isSideBannerAvailable">
                    <ng-container [ngTemplateOutlet]="banner"></ng-container>
                </div>
                <div class="dashboard-item-wrapper">
                    <ng-container [ngTemplateOutlet]="events"></ng-container>
                </div>
                <div class="dashboard-item-wrapper" *ngIf="!isDEUser">
                    <ng-container [ngTemplateOutlet]="newsItems"></ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="giftBox" *ngIf="showGiftBox">
        <div id="giftPanel" class="giftIcon">
            <img class="ellipse16" src="../../../../assets/icons/Ellipse 16.svg" alt="UPS">
            <img class="gift" (click)="open_gift()" src="../../../../assets/icons/gift2.svg" alt="UPS">
            <h1 *ngIf="getComplimentaryScores">Get 50 Complimentary Scores</h1>
            <img *ngIf="getComplimentaryScores" (click)="close_gift()" class="close" src="../../../../assets/icons/close.svg"
                alt="UPS">

        </div>

    </div>
    <div class="dashboard-footer">
        &copy; {{ getCurrentYear() }} {{ 'siteFooter' | translate }}
    </div>
</div>

<ng-template #header>
    <div class="ups-page-header">
        <h1 class="page-title">Hello, {{ user?.FirstName }}!</h1>
    </div>
</ng-template>

<ng-template #announcement>
    <div class="dashboard-item announcement" *ngIf="announcements && announcements.length">
        <h4 class="title">{{ announcements[0].Title }}</h4>
        <upsc-truncated-paragraph [text]="announcements[0].Content"
            [characterCountLimit]="dashboardAnnouncementConfig.characterLimit"
            [lineCountLimit]="dashboardAnnouncementConfig.lineLimit"></upsc-truncated-paragraph>
    </div>
</ng-template>

<ng-template #banner>
    <div class="dashboard-item sidebanner">
        <a [href]="dashboardBannerConfig.images[0].sideDashboardLinkUrl" target="_blank">
            <img [src]="dashboardBannerConfig.images[0].sideDashboardImageUrl" alt="Side Banner" />
        </a>
    </div>
</ng-template>

<ng-template #events>
    <div class="dashboard-item events">
        <h4 class="title">
            <img class="icon" src="../../../../assets/icons/calendar-symbol.svg" alt="upcoming events">
            <span>{{'dashboard.upcomingEvents' | translate}}</span>
        </h4>
        <upsc-event-list [items]="upcomingEvents"></upsc-event-list>
    </div>
</ng-template>

<ng-template #newsItems>
    <div class="dashboard-item news">
        <h4 class="title">
            <img class="icon" src="../../../../assets/icons/megaphone.svg" alt="news">
            <span>{{'dashboard.news'|translate}}</span>
        </h4>
        <upsc-news-list [items]="news"></upsc-news-list>
    </div>
</ng-template>

<ng-template #trackShipment>
    <div class="dashboard-item track-shipment">
        <h4 class="title">
            <span>{{'dashboard.trackShipment'|translate}}</span>
        </h4>
        <h6 class="subtitle">{{'dashboard.getPackageStatus'|translate}}</h6>

        <form class="ups-form">
            <div class="form-body">
                <mat-form-field floatLabel="auto">
                    <input matInput placeholder="{{'dashboard.enterTrackingNo'|translate}}">
                </mat-form-field>
            </div>

            <div class="form-footer">
                <div class="form-actions">
                    <button type="submit" mat-raised-button color="primary" [disabled]="true">
                        {{'dashboard.Track'|translate}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #costEstimator>
    <div class="dashboard-item cost-estimator" *ngIf="userRoutes?.CostEstimator">
        <h4 class="title">
            <img class="icon" src="../../../../assets/icons/calculator.svg" alt="Cost Estimator">
            <span>{{'dashboard.costEstimator'|translate}}</span>
        </h4>
        <p class="center">
            {{'dashboard.compareCost'|translate}}<br>
            {{'dashboard.competitiveRates'|translate}}
        </p>
        <div class="cost-estimator-actions">
            <button type="button" mat-raised-button class="alternative-button" (click)="openCostEstimator($event)">
                {{'GetQuote'|translate}}
            </button>
        </div>
    </div>
</ng-template>

<ng-template #rewardShip>
    <div class="dashboard-item reward-ship">
        <h4 class="title">{{'RewardShip'|translate}}</h4>
        <p class="center cta">
            $100.00
        </p>
        <h6 class="subtitle">{{'RedeemableCredits'|translate}}</h6>
        <p class="center">
            {{'dashboard.payOnTime'|translate}}
        </p>
        <div class="actions">
            <a type="button" mat-raised-button color="primary"
                routerLink="/rewardship">{{'dashboard.viewCredits'|translate}}</a>
        </div>
    </div>
</ng-template>

<ng-template #eInvoice>
    <div class="dashboard-item e-invoice">
        <h4 class="title">{{'dashboard.signupEinvoice'|translate}}</h4>
        <h6 class="subtitle">{{'emailInvoices'|translate}}</h6>
        <p class="center">
            {{'eInvoiceAdvantage'|translate}}
        </p>
        <div class="actions">
        </div>
    </div>
</ng-template>

<ng-template #shipUps>
    <div class="dashboard-item ship-ups">
        <h4 class="title">
            <span>{{'dashboard.shipWith'|translate}}</span>
            <img class="icon" src="../../../../assets/icons/logo-ups.svg" alt="UPS">
        </h4>
        <p>
            {{'dashboard.createUpsShippingLabel'|translate}} <br> and earn 
            <a routerLink="/dw-rewardship">
                <span>{{'dashboard.rewardShip'|translate}}</span>
            </a>
            points
        </p>
        <!-- <p>
            {{'dashboard.createUpsShippingLabel'|translate}} <br> and earn Rewardship points
        </p> -->
        <div class="actions">
            <a routerLink="/ship/ups" mat-raised-button>{{'dashboard.createUpsLabel'|translate}}</a>
        </div>
    </div>
</ng-template>

<ng-template #shipFedEx>
    <div class="dashboard-item ship-fedex">
        <h4 class="title">
            <span>{{'dashboard.shipWith'|translate}}</span>
            <img class="icon" src="../../../../assets/icons/logo-fedex.svg" alt="FedEx">
        </h4>
        <p>
            {{'dashboard.createFedexShippingLabel'|translate}}
        </p>
        <div class="actions">
            <a routerLink="/ship/fedex" mat-raised-button>{{'dashboard.createFedexLabel'|translate}}</a>
        </div>
    </div>
</ng-template>

<ng-template #restrictedZip>
    <div class="dashboard-item restricted-zip">
        <a routerLink="/support/restricted-zip-codes">
            <span>{{'dashboard.viewRestrictedZipCodes'|translate}}</span>
            <mat-icon>arrow_forward</mat-icon>
        </a>
    </div>
</ng-template>

<ng-template #packagingChecklist>
    <div class="dashboard-item packaging-checklist">
        <a href="#" (click)="downloadPackagingChecklist($event)">
            <mat-icon>check</mat-icon>
            <span>{{'dashboard.safePackagingChecklist'|translate}}</span>
        </a>
        <upsc-s3-file-downloader [hidden]="true" #packagingChecklistDownloader [bucketName]="'members-pdf.upsc'"
            [fileName]="(storageService.getAsText('lang') === 'de') ? 'German Safe Shipping and Packaging Checklist.pdf' : 'packaging_checklist.pdf'"
            (fileDownloadEnded)="onPackagingChecklistDownloadEnded($event)"></upsc-s3-file-downloader>
        <upsc-element-blocker *ngIf="isPackagingChecklistDownloading"></upsc-element-blocker>
    </div>
</ng-template>

<ng-template #quickTrack>
    <div class="dashboard-item quick-track" [hidden]="!userRoutes?.ShipmentHistory">
        <h4 class="title">
            <img class="icon" src="../../assets/icons/location.svg" alt="Quick Track">
            <span>{{'dashboard.quickTrack'|translate}}</span>
        </h4>

        @if (user.CountryCode === "US") {
            <a class="see-all-tracks" routerLink="/track-shipments">{{ 'dashboard.seeAll'|translate }}</a>
        } @else {
            <a class="see-all-tracks" routerLink="/shipment-history">{{ 'dashboard.seeAll'|translate }}</a>
        }

        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border compact">
            <thead>
                <tr>
                    <th width="*">{{'Recipient'|translate}}</th>
                    <th width="33.3333333%" class="text-center">{{'TrackingNumber'|translate}}</th>
                    <th width="33.3333333%" class="text-center">{{'Status'|translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let shipment of quickTrackShipments">
                    <td class="recipient text-ellipsis">
                        <span matTooltip="{{ getShipmentRecipient(shipment) }}" [matTooltipPosition]="'right'">{{
                            getShipmentRecipient(shipment) }}</span>
                    </td>
                    <td class="text-center tracking-number">
                        <a href="#" (click)="openTrackedShipmentDialog($event, shipment)">{{ shipment.TrackingNumber
                            }}</a>
                    </td>
                    <td class="text-center status">{{ shipment.LastScanDescription }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>


<!-- <div class="dw-dashboard">
    <div class="colum-layout">
        <div class="row-layout">
            <div class="text"> We’ve updated our RewardShip Program <span class="text-link">Terms and Conditions</span>, effective October 23, 2023.</div>
        </div>

        <div class="rectangle"></div>

        <div class="cards">
        <div class="card">
            <div class="card-content">
                <div class="card-content-1">
                    <div class="shipwith"> Ship With</div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-content">
                <div class="card-content-1">
                    <div class="shipwith"> Ship With</div>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-content">
                <div class="card-content-1">
                    <div class="shipwith"> Ship With</div>
                </div>
            </div>
        </div>
        <div class="events">T</div>
        <div class="events">M</div>
    </div>
</div>
</div> -->
